/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/ui/WidgetAddUIHelper'
], function(WidgetAddUIHelper){

	/**
	 * Extension of the WidgetAddUIHelper that allows entries to be built up by querying the list of definitions
	 * rather than a static json list
	 *
	 * This is a LiveWidget version of WidgetAddUIHelper which uses the livewidget and VisDefinitions feature of the livewidget
	 */
	var LiveWidgetUIHelper = WidgetAddUIHelper.extend({

		init: function(params){
			LiveWidgetUIHelper.inherited('init', this, arguments);
			this.dashboardApi = params.dashboardApi;
			this.iconsFeature = this.dashboardApi.getFeature('Icons');
		},

		/**
		 * Build up a livewidget entry for each possible archetype, use the archetype icon as the icon
		 * to see in the visualizations drop down
		 */
		getEntries: function() {
			const definitionAPI = this.dashboardApi.getFeature('VisDefinitions');
			return definitionAPI.getList().filter(definition => {
				return definition.getProperty('recommendOnly') !== true;
			})
				.map(definition => {
					return {
						label: definition.getLabel(),
						name: definition.getId(),
						icon: this._getVisualizationIcon(definition),
						type: definition.getType(),
						placeholderIcon: definition.getPlaceholderIconUri(),
						content: {
							title: definition.getId(),
							iconUrl: definition.getIconUri(),
							name: definition.getId(),
							widget: 'dashboard-analytics/widgets/livewidget/LiveWidget',
							options: {
								visId: definition.getId(),
								avatarIcon: definition.getPlaceholderIconUri()
							}
						}
					};
				});
		},

		_getVisualizationIcon(definition){
			let icon = this.iconsFeature.getIcon(definition.getIcon());
			icon = icon === undefined ? definition.getIcon() : icon.id;
			return icon;
		}

	});
	return LiveWidgetUIHelper;
});
